import './SeeAllButton.scss';
import * as React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Link } from 'react-router-dom';
import { SearchResultSectionType } from 'src/state/SearchResult';
import { IconChevronRight } from 'src/components/Icon/IconChevronRight';

type Props = {
    readonly count: number;
    readonly query: string;
    readonly section: SearchResultSectionType;
};

export function SeeAllButton({ count, query, section }: Props): JSX.Element {
    return (
        <Link className="lvo-see-all-button"
              to={`?query=${encodeURIComponent(query)}&section=${encodeURIComponent(section)}`}
              replace={true}>
            <div className="lvo-see-all-button__text">
                <FormattedMessage id="searchPage_seeAllResults" values={{
                    count: <FormattedNumber value={count}/>,
                    section: <FormattedMessage id="searchPage_sectionName" values={{ section }}/>,
                }}/>
            </div>
            <div className="lvo-see-all-button__icon">
                <IconChevronRight/>
            </div>
        </Link>
    );
}
